import axios, { AxiosResponse } from "axios"

export type ProposeData = {
    terms: boolean;
    topic: string;
    message: string;
}

export async function proposeArticle(propose: ProposeData): Promise<AxiosResponse<ProposeData>> {
    try {
        const res = await axios.post(`${window.API_HOST}/api/propose-article`, propose)
        return res.data
    } catch (err) {
        if (axios.isAxiosError(err)) {
            throw { status: err.response!.status, errors: err.response!.data.errors }
        } else {
            throw new Error('Cannot login.')
        }
    }
}